export const QUERY__TRANSACTION_HISTORY = 'transaction-history';
export const QUERY__PROMO_MONEY_TRANSACTIONS = 'promo-money-transactions';
